import { useQuery } from "@tanstack/react-query";

import { type ProductClient } from "@fitness-app/data-models/entities/ProductClient";

import { traineeKeys, useTraineeId, useTraineeProfile } from "~/modules/Trainee/TraineeProfile/scope";
import { supabase } from "~/store/initializeStore";

// Rozmiar strony jak w `productClients.listSize` - zakładka pokazuje tylko pierwszą stronę.
const PRODUCT_CLIENTS_PAGE_SIZE = 25;

export const traineeProductClientsKey = (traineeId: string) =>
  [...traineeKeys.all(traineeId), "productClients"] as const;

/** Pakiety klientki (to samo co `fetchProductClients({ clientEmail })`, ale per karta). */
export const useTraineeProductClients = () => {
  const traineeId = useTraineeId();
  const email = useTraineeProfile().data?.email;

  return useQuery({
    queryKey: [...traineeProductClientsKey(traineeId), email],
    enabled: Boolean(email),
    queryFn: async () => {
      const { data, error } = await supabase
        .from("product_client")
        .select("*")
        .order("createdAt", { ascending: false })
        .eq("email", email!)
        .range(0, PRODUCT_CLIENTS_PAGE_SIZE - 1)
        .limit(PRODUCT_CLIENTS_PAGE_SIZE)
        .returns<ProductClient[]>();

      if (error) {
        throw new Error(error.message);
      }

      return data;
    },
  });
};
